import { FC, useState } from "react";
import { Box, Button } from "@mui/material";
import "./LoginCarousel.scss";
import mobileLoginStartupBg from "../../../assets/images/login-startup-bg-modified4x.png";
import loginStartupImg1 from "../../../assets/images/login-startup-image1-modified.svg";
import loginStartupImg2 from "../../../assets/images/login-startup-image2-modified.svg";
import useWindowSize from "../../../hooks/useWindowSize";
import LoginStartupTitle from "./LoginStartupTitle";

interface Props {
  setLoginCarousel: Function;
}
const WebLoginStartup: FC<Props> = ({ setLoginCarousel }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const { height } = useWindowSize();

  const handleNext = () => {
    if (currentIndex === 1) {
      setLoginCarousel(false);
    } else {
      setCurrentIndex((prevIndex) => prevIndex + 1);
    }
  };

  let btnLabel = currentIndex === 0 ? "Next" : "Let’s get started";
  let imgSrc = currentIndex === 0 ? loginStartupImg1 : loginStartupImg2;
  let title =
    currentIndex === 0
      ? ["We have", "upgraded the", "experience for you"]
      : ["One time", "additional", "security verification"];
  let subTitle =
    currentIndex === 0
      ? ["Login easily with the convenience of", "your ", "mobile number only"]
      : [
          "Authenticate once to sync your",
          "holdings and ",
          "verify your details",
        ];
  return (
    <Box
      className="web-login-startup-body"
      display="flex"
      flexDirection="column"
      sx={{
        backgroundImage: `url(${mobileLoginStartupBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        height: "100%",
      }}
    >
      <LoginStartupTitle
        title={title}
        subTitle={subTitle}
        isMobile={false}
        image={imgSrc}
        height={height}
      />
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        marginTop="1.125rem"
      >
        <Box
          display="flex"
          justifyContent="center"
          marginTop="auto"
          paddingX="1rem"
          boxShadow="-15px -15px 40px 0px #0000000F"
        >
          <Button
            variant="contained"
            onClick={handleNext}
            sx={{
              boxShadow: "none",
              marginY: "1rem",
              width: "13rem",
              paddingY: ".875rem",
            }}
          >
            {btnLabel}
          </Button>
        </Box>
      </Box>
      <img src={loginStartupImg1} style={{ visibility: "hidden", height: 0 }} />
      <img src={loginStartupImg2} style={{ visibility: "hidden", height: 0 }} />
    </Box>
  );
};

export default WebLoginStartup;
